import {mixins} from "../app/mixin";

mixins.push(
  {
    el: 'homepage',
    data() {
      return {
        activeSolutionIndex: 0,
        
        _tabsCount: 0,
        _tabsContainerEl: null,
        _onTabsClick: null,
        
        _tabContentsEl: null,
        _onTouchStart: null,
        _onTouchMove: null,
        _onTouchEnd: null,
        _touchStartX: 0,
        _touchStartY: 0,
        _touchDeltaX: 0,
        _touchDeltaY: 0,
        _touchActive: false,
        
        _onResize: null
      }
    },
    mounted() {
      this._tabContentsEl = document.querySelector('.enterprise-solutions .tab-contents');
      if (this._tabContentsEl) {
        this._tabsCount = this._tabContentsEl.querySelectorAll('.tab-content').length || 0;
      }
      
      // Desktop (>=603px)
      this.bindTabsClick();
      
      // Mobile (<=602px)
      this.setupSwipeIfMobile();
      
      this._onResize = () => {
        this.setupSwipeIfMobile();
      };
      window.addEventListener('resize', this._onResize, { passive: true });
    },
    beforeDestroy() {
      if (this._tabsContainerEl && this._onTabsClick) {
        this._tabsContainerEl.removeEventListener('click', this._onTabsClick);
      }
      this.teardownSwipe();
      
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize);
      }
    },
    methods: {
      isMobile() {
        return (window.innerWidth || document.documentElement.clientWidth || 0) <= 602;
      },
      
      setActiveSolutionIndex(index) {
        if (typeof index !== 'number') return;
        if (this._tabsCount > 0) {
          this.activeSolutionIndex = ((index % this._tabsCount) + this._tabsCount) % this._tabsCount;
        } else {
          this.activeSolutionIndex = index;
        }
      },
      
      goNext() {
        if (this._tabsCount <= 0) return;
        this.activeSolutionIndex = (this.activeSolutionIndex + 1) % this._tabsCount;
      },
      
      goPrev() {
        if (this._tabsCount <= 0) return;
        this.activeSolutionIndex = (this.activeSolutionIndex - 1 + this._tabsCount) % this._tabsCount;
      },
      
      bindTabsClick() {
        const container = document.querySelector('.enterprise-solutions .tabs');
        if (!container) return;
        
        this._tabsContainerEl = container;
        this._onTabsClick = (e) => {
          if (this.isMobile()) return;
          
          const tab = e.target.closest('.tab');
          if (!tab || !container.contains(tab)) return;
          
          const tabs = Array.from(container.querySelectorAll('.tab'));
          const idx = tabs.indexOf(tab);
          if (idx > -1) this.setActiveSolutionIndex(idx);
        };
        
        container.addEventListener('click', this._onTabsClick);
      },
      
      setupSwipeIfMobile() {
        if (!this._tabContentsEl) return;
        
        if (this.isMobile()) {
          this.attachSwipeListeners();
        } else {
          this.teardownSwipe();
        }
      },
      
      attachSwipeListeners() {
        if (!this._tabContentsEl || this._onTouchStart) return;
        
        this._onTouchStart = (e) => {
          const t = e.touches ? e.touches[0] : e;
          this._touchStartX = t.clientX;
          this._touchStartY = t.clientY;
          this._touchDeltaX = 0;
          this._touchDeltaY = 0;
          this._touchActive = true;
        };
        
        this._onTouchMove = (e) => {
          if (!this._touchActive) return;
          const t = e.touches ? e.touches[0] : e;
          this._touchDeltaX = t.clientX - this._touchStartX;
          this._touchDeltaY = t.clientY - this._touchStartY;
          
          if (Math.abs(this._touchDeltaY) > Math.abs(this._touchDeltaX)) return;
        };
        
        this._onTouchEnd = () => {
          if (!this._touchActive) return;
          const THRESHOLD = 50;
          const absX = Math.abs(this._touchDeltaX);
          const absY = Math.abs(this._touchDeltaY);
          
          if (absX > absY && absX >= THRESHOLD) {
            // swipe left => next one
            if (this._touchDeltaX < 0) {
              this.goNext();
            } else {
              // swipe right => prev one
              this.goPrev();
            }
          }
          this._touchActive = false;
        };
        
        this._tabContentsEl.addEventListener('touchstart', this._onTouchStart, { passive: true });
        this._tabContentsEl.addEventListener('touchmove', this._onTouchMove, { passive: true });
        this._tabContentsEl.addEventListener('touchend', this._onTouchEnd, { passive: true });
      },
      
      teardownSwipe() {
        if (!this._tabContentsEl) return;
        
        if (this._onTouchStart) {
          this._tabContentsEl.removeEventListener('touchstart', this._onTouchStart);
          this._tabContentsEl.removeEventListener('touchmove', this._onTouchMove);
          this._tabContentsEl.removeEventListener('touchend', this._onTouchEnd);
          this._onTouchStart = this._onTouchMove = this._onTouchEnd = null;
        }
        this._touchActive = false;
      }
    }
  }
);
